import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { offeringsDraftRoute } from '..';

export const offeringsDraftNewRoute = createRoute({
  getParentRoute: () => offeringsDraftRoute,
  path: 'new',
  component: lazyRouteComponent(() => import('./OfferingsDraftNewView')),
});
